import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.padd = document.querySelector( 'div.h-header-height-no-lang' );
        this.onResize();
        this.onResizeBind = this.onResize.bind( this );
        window.addEventListener( 'resize', this.onResizeBind );
    }
    onResize(){
        this.padd.style.marginBottom = this.$( 'height')[0].getBoundingClientRect().height + 'px';

    }
    init() {}
    destroy(){
        window.removeEventListener( 'resize', this.onResizeBind );
    }
}
